import { useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { api, formatApiErrorDetail } from "@/lib/api";
import { toast } from "@/lib/toast";
import { Lock, Eye, EyeOff } from "lucide-react";

export default function ResetPassword() {
  const [sp] = useSearchParams();
  const token = sp.get("token") || "";
  const [pw, setPw] = useState("");
  const [show, setShow] = useState(false);
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();
  const submit = async (e) => {
    e.preventDefault();
    if (!pw) { toast.error("Enter a new password"); return; }
    setBusy(true);
    try { await api.post("/auth/reset-password", { token, new_password: pw }); toast.success("Password changed. Please sign in."); nav("/login"); }
    catch (e) { toast.error(formatApiErrorDetail(e?.response?.data?.detail)); }
    finally { setBusy(false); }
  };
  return (
    <div className="jali min-h-[70vh] flex items-start justify-center px-4 py-12 sm:py-20">
      <div className="w-full max-w-md card-heritage p-6 sm:p-9">
        <h1 className="font-display text-[34px] sm:text-4xl text-[color:var(--maroon)] leading-tight">Set a new password</h1>
        <form onSubmit={submit} noValidate className="mt-6 space-y-4">
          <label className="block">
            <span className="label">New password</span>
            <span className="relative block">
              <Lock className="w-4 h-4 absolute left-4 top-1/2 -translate-y-1/2 text-[color:var(--gold)]"/>
              <input type={show ? "text" : "password"} autoComplete="new-password" placeholder="New password" value={pw} onChange={(e) => setPw(e.target.value)} className="input !pl-11 !pr-11"/>
              <button type="button" onClick={() => setShow(!show)} className="absolute right-3 top-1/2 -translate-y-1/2 text-neutral-500" aria-label="Toggle password">{show ? <EyeOff className="w-4 h-4"/> : <Eye className="w-4 h-4"/>}</button>
            </span>
          </label>
          <button disabled={busy} className="btn-wine w-full !py-3.5">{busy ? "Saving…" : "Save new password"}</button>
        </form>
        <div className="mt-6 text-sm"><Link to="/login" className="text-[color:var(--maroon)] font-semibold underline underline-offset-4">Back to sign in</Link></div>
      </div>
    </div>
  );
}
